import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../components/primitives/SMLButton';
import { AddArtistModal } from '../../accountSelector/AddArtistModal';
import { artistHomeMessages as messages } from './artistHomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * A workspace with no artist (design b1, c3): one card. The button opens the same "Add an artist"
 * flow as the switcher.
 */
const ArtistHomeNoArtistComponent: React.FC = () => {
  const intl = useIntl();
  const [isAddOpen, setAddOpen] = useState(false);

  const openAdd = useCallback(() => setAddOpen(true), []);
  const closeAdd = useCallback(() => setAddOpen(false), []);

  return (
    <div className={styles.addArtist}>
      <span className={clsx(styles.setupIcon, styles.addArtistIcon)}>
        <FontAwesomeIcon icon={faUserPlus} size="lg" />
      </span>
      <h2>{intl.formatMessage(messages.noArtistTitle)}</h2>
      <p>{intl.formatMessage(messages.noArtistBody)}</p>
      <SMLButton variant="primary" icon={<FontAwesomeIcon icon={faPlus} />} onClick={openAdd}>
        {intl.formatMessage(messages.noArtistCta)}
      </SMLButton>
      <AddArtistModal isOpen={isAddOpen} onClose={closeAdd} />
    </div>
  );
};

export const ArtistHomeNoArtist = TypedMemo(ArtistHomeNoArtistComponent);
